import { render, staticRenderFns } from "./PackagesList.vue?vue&type=template&id=5e66ff1b&scoped=true"
import script from "./PackagesList.vue?vue&type=script&lang=js"
export * from "./PackagesList.vue?vue&type=script&lang=js"
import style0 from "./PackagesList.vue?vue&type=style&index=0&id=5e66ff1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e66ff1b",
  null
  
)

export default component.exports